import React, { useEffect } from 'react';
import { Outlet, PathParam, useParams } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import Routes from 'config/routes';
import { Module_Enum, useGetShiftReportNameQuery } from 'generated/graphql';

import Page from './page';

interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  img?: { src: string; alt: string };
  footer?: React.ReactNode;
}

// This page is required to switch the currentContructionSite if the user open
// a shift report from the url
function ReportConnectedPage(props: Props) {
  const {
    isConnected,
    currentConstructionSiteId,
    setCurrentConstructionSiteId,
  } = useAppContext();
  const { t } = useTranslation();
  const { id } = useParams<PathParam<Routes.ReportView | Routes.ReportEdit>>();

  const graphqlHeaders = useGraphqlApiHeaders(Module_Enum.DataAnalysis);
  const { data } = useGetShiftReportNameQuery({
    variables: { id },
    skip: !id,
    context: { headers: graphqlHeaders },
  });

  const navTitle = t('module.header', { context: Module_Enum.ShiftReport });

  useEffect(() => {
    if (
      data?.shiftReport?.constructionSiteId &&
      data.shiftReport.constructionSiteId !== currentConstructionSiteId
    ) {
      setCurrentConstructionSiteId(data?.shiftReport?.constructionSiteId);
    }
  });

  return (
    <Page
      {...props}
      isConnected={isConnected}
      title={navTitle}
      constructionSiteChangeEnabled={false}
    >
      <Outlet />
    </Page>
  );
}

export default ReportConnectedPage;
